export default "__VITE_ASSET__U6bLEWvv__"